import React from 'react';
import { Button, ButtonGroup } from "@blueprintjs/core";

import TemplateSelectorDialog from './message_template_dialog/message_template_dialog.js';
import SearchContactDialog from './template_dialog/template_dialog.js';
import SearchClientDialog from './clients_template_dialog/clients_template_dialog.js';
import Agente from "../../models/Agente";

/**
 *
 * @property {Object} props
 * @property {Agente} props.currentAgent
 */
class AgentBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchContactDialogIsOpen: false,
            searchClientDialogIsOpen: false,
            templateSelectorDialogIsOpen: false,
            templateSelectorDialogActiveContact: {}
        }

        this.closeSearchContactDialog = this.closeSearchContactDialog.bind(this);
        this.openSearchContactDialog = this.openSearchContactDialog.bind(this);
        this.closeTemplateSelectorDialog = this.closeTemplateSelectorDialog.bind(this);
        this.openTemplateSelectorDialog = this.openTemplateSelectorDialog.bind(this);
        this.closeSearchClientDialog = this.closeSearchClientDialog.bind(this);
        this.openSearchClientDialog = this.openSearchClientDialog.bind(this);
        this.setContact = this.setContact.bind(this);
        this.setClient = this.setClient.bind(this);

        this.profileSettings= props.profileSettings;
        this.dropdownChild   = React.createRef();
        this.openDropdown = this.openDropdown.bind(this);
        document.body.addEventListener('click', this.closeDropdown.bind(this));
        this.openProfileSettings  = this.openProfileSettings.bind(this);

        this.redirectToBroadcastLists  = this.redirectToBroadcastLists.bind(this);
    }

    redirectToBroadcastLists() {
        window.location = "#/broadcast_lists"
    }

    setContact(activeNumber) {
        this.closeSearchContactDialog()
        this.openTemplateSelectorDialog(activeNumber)
    }

    closeTemplateSelectorDialog() {
        this.setState({
            templateSelectorDialogIsOpen: false,
            templateSelectorDialogActiveContact: {}
        });
    }

    openTemplateSelectorDialog(activeContact) {
        console.log("activeContact");
        console.log(activeContact);
        
        this.setState({
            templateSelectorDialogIsOpen: true,
            templateSelectorDialogActiveContact: activeContact
        });
    }

    closeSearchContactDialog(){
        this.setState({ searchContactDialogIsOpen: false });
    }

    openSearchContactDialog(){
        this.setState({ searchContactDialogIsOpen: true });
    }

    closeSearchClientDialog(){
        this.setState({ searchClientDialogIsOpen: false });
    }

    openSearchClientDialog(){
        this.setState({ searchClientDialogIsOpen: true });
    }

    openProfileSettings() {
      //this.profileSettings.current.style.left = 0;
    }

    openDropdown() {
        this.dropdownChild.current.classList.add("show")
    }

    closeDropdown() {
        this.dropdownChild.current.classList.remove("show")
    }

    setClient(activeClient) {
        this.closeSearchClientDialog()
        this.openTemplateSelectorDialog(activeClient)
    }


    renderLogInButton() {
        const that = this;
        if (this.props.currentAgent == null) {
            const handleLogin = () => {
                this.closeDropdown();
                this.props.logIn();
            };
            return <button className="dropdown-item" onClick={handleLogin}>Iniciar sesión</button>
        }

        let options = [
            {icon: 'search',
                action: () => { this.closeDropdown(); this.openSearchClientDialog(); },
                text: 'Buscar cliente',
                rule: Agente.RULE_CAN_SEARCH_CLIENT},
            {icon: 'search',
                action: () => { this.closeDropdown(); this.openSearchContactDialog(); },
                text: 'Buscar contacto',
                rule: Agente.RULE_CAN_SEARCH_CONTACT},
            {icon: 'send-message',
                action: () => { this.closeDropdown(); this.openTemplateSelectorDialog({}); },
                text: 'Enviar mensaje',
                rule: Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES},
            {icon: 'feed',
                action: () => { this.closeDropdown(); this.redirectToBroadcastLists(); },
                text: 'Listas de difusión',
                rule: Agente.RULE_CAN_OPEN_BROADCAST},
        ];
        return (
            <ButtonGroup minimal={true} vertical={true} alignText="left" large={true} fill={true}>
                {options.map((value, index) => {
                    if(!that.props.currentAgent.can(value.rule)) {
                        return;
                    }
                    return <Button icon={value.icon} onClick={value.action} key={index}>{value.text}</Button>;
                })}
                <Button icon="log-out" onClick={() => { this.closeDropdown(); this.props.logOut(); }}>Cerrar sesión</Button>
            </ButtonGroup>
        )
    }
    render() {
        let displayName;

        const currentAgent = this.props.currentAgent;
        if(currentAgent == null) {
            displayName = "Sin conexión";
        } else {
            displayName = this.props.currentAgent.displayName.toLowerCase();
        }
        const isLXP = currentAgent && currentAgent.usuario && currentAgent.can(Agente.RULE_CAN_OPEN_DIRECTORY);

        return (
        <div>
            <div className="row d-flex flex-row align-items-center p-2" id="navbar">
                <img alt="Profile" className="img-fluid rounded-circle mr-2" style={{height:"50px", cursor:"pointer"}}
                     src={this.props.agentImage} onClick={this.openProfileSettings}></img>
                <div className="font-weight-bold" id="username" style={{textTransform: "capitalize"}}>{displayName}</div>
                <div className="nav-item ml-auto">
                    {
                        isLXP ? <button className="btn nav-link" onClick={this.props.openDirectory}><i className="fas fa-comment-alt fa-lg"></i></button>
                        : ""
                    }
                </div>
                <div className="nav-item dropdown" onClick={this.openDropdown}>
                    <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#_" role="button" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-v fa-lg"></i></a>
                    <div ref={this.dropdownChild} className="dropdown-menu dropdown-menu-right">
                        {this.renderLogInButton()}
                    </div>
                </div>
            </div>
            <SearchContactDialog
              isOpen={this.state.searchContactDialogIsOpen}
              close={this.closeSearchContactDialog}
              templateList={this.props.templateList}
              currentAgent={this.props.currentAgent}
              setContact={this.setContact}
            />
            <SearchClientDialog
              isOpen={this.state.searchClientDialogIsOpen}
              close={this.closeSearchClientDialog}
              currentAgent={this.props.currentAgent}
              setClient={this.setClient}
            />
            <TemplateSelectorDialog
              isOpen={this.state.templateSelectorDialogIsOpen}
              close={this.closeTemplateSelectorDialog}
              templateList={this.props.templateList}
              currentAgent={this.props.currentAgent}
              defaultValue={this.state.templateSelectorDialogActiveContact}
              quickReplies={this.props.quickReplies}
              attentionDays={this.props.attentionDays}
              parameter={this.props.parameter}
            />
        </div>
        )
    }
}

export default AgentBar;
